/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'
import { Box, BoxProps, Text } from '@mantine/core'

export type LabelledValueProps = BoxProps & {
  label: string
  value?: ReactNode
}

function Value (v?: ReactNode) {
  if (v === null) {
    return ''
  }
  if (typeof v === 'boolean') {
    return <>
      {v
        ? <FormattedMessage
          id="yes"
          defaultMessage="Oui"
        />
        : <FormattedMessage
          id="no"
          defaultMessage="Non"
        />
      }
    </>
  }
  return v
}

function LabelledValue (props: LabelledValueProps) {
  const { label, value, ...others } = props
  return (
    <Box {...others}>
      <Text inherit span c="dimmed">{`${label} : `}</Text>
      <Text inherit span>{Value(value)}</Text>
    </Box>
  )
}

export default LabelledValue
